import { loadGtmIfNeed } from '$components/GtmDatalayer/loadGtmIfNeed';

export function getDatalayer(gtmId: string): object[] | null {
    if (typeof window === 'undefined') {
        return null;
    }

    loadGtmIfNeed(gtmId);
    const w: any = window; // eslint-disable-line @typescript-eslint/no-explicit-any
    return w.dataLayer as object[]; // eslint-disable-line @typescript-eslint/no-unsafe-member-access
}
